import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LocaleProvider, useLocale } from './context/LocaleContext';
import Login from './pages/Login';
import DashboardShell from './components/DashboardShell';
import InboxPage from './pages/inbox/InboxPage';
import ConversationsPage from './pages/conversations/ConversationsPage';
import BonnieFAQs from './pages/bonnie/BonnieFAQs';
import BonnieDocuments from './pages/bonnie/Documents';
import BonnieScenarios from './pages/bonnie/Scenarios';
import BonniePlayground from './pages/bonnie/Playground';
import BonnieInboxes from './pages/bonnie/Inboxes';
import BonnieTools from './pages/bonnie/Tools';
import ContactsPage from './pages/contacts/ContactsPage';
import ReportsOverview from './pages/reports/Overview';
import ReportsConversations from './pages/reports/Conversations';
import ReportsAgents from './pages/reports/Agents';
import CampaignsIndex from './pages/campaigns/CampaignsIndex';
import LiveChatPage from './pages/campaigns/LiveChatPage';
import HelpArticles from './pages/help/Articles';
import HelpCategories from './pages/help/Categories';
import HelpLocales from './pages/help/Locales';
import AccountSettingsPage from './pages/Settings';
import SettingsAgentsPage from './pages/settings/AgentsPage';
import SettingsTeamsPage from './pages/settings/TeamsPage';
import SettingsInboxesPage from './pages/settings/InboxesPage';
import SettingsLabelsPage from './pages/settings/LabelsPage';
import SettingsAutomationPage from './pages/settings/AutomationPage';
import SettingsCannedResponsesPage from './pages/settings/CannedResponsesPage';
import SettingsIntegrationsPage from './pages/settings/IntegrationsPage';
import SettingsAuditLogsPage from './pages/settings/AuditLogsPage';
import './App.css';

function ProtectedLayout() {
  const { token, user, bootstrapping } = useAuth();
  const { t } = useLocale();

  if (bootstrapping) {
    return (
      <div className="auth-bootstrapping">
        <p>{t('app.loading')}</p>
      </div>
    );
  }
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedLayout />}>
        <Route element={<DashboardShell />}>
          <Route path="/" element={<Navigate to="/conversations" replace />} />
          <Route path="/inbox" element={<InboxPage />} />
          <Route path="/conversations" element={<ConversationsPage />} />
          <Route path="/conversations/mentions" element={<ConversationsPage />} />
          <Route path="/conversations/unattended" element={<ConversationsPage />} />
          <Route path="/bonnie/faqs" element={<BonnieFAQs />} />
          <Route path="/bonnie/documents" element={<BonnieDocuments />} />
          <Route path="/bonnie/scenarios" element={<BonnieScenarios />} />
          <Route path="/bonnie/playground" element={<BonniePlayground />} />
          <Route path="/bonnie/inboxes" element={<BonnieInboxes />} />
          <Route path="/bonnie/tools" element={<BonnieTools />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/reports/overview" element={<ReportsOverview />} />
          <Route path="/reports/conversations" element={<ReportsConversations />} />
          <Route path="/reports/agents" element={<ReportsAgents />} />
          <Route path="/campaigns" element={<CampaignsIndex />} />
          <Route path="/campaigns/live-chat" element={<LiveChatPage />} />
          <Route path="/help/articles" element={<HelpArticles />} />
          <Route path="/help/categories" element={<HelpCategories />} />
          <Route path="/help/locales" element={<HelpLocales />} />
          <Route path="/settings/account" element={<AccountSettingsPage />} />
          <Route path="/settings/agents" element={<SettingsAgentsPage />} />
          <Route path="/settings/teams" element={<SettingsTeamsPage />} />
          <Route path="/settings/inboxes" element={<SettingsInboxesPage />} />
          <Route path="/settings/labels" element={<SettingsLabelsPage />} />
          <Route path="/settings/automation" element={<SettingsAutomationPage />} />
          <Route path="/settings/canned-responses" element={<SettingsCannedResponsesPage />} />
          <Route path="/settings/integrations" element={<SettingsIntegrationsPage />} />
          <Route path="/settings/audit-logs" element={<SettingsAuditLogsPage />} />
          <Route path="/dashboard" element={<Navigate to="/conversations" replace />} />
          <Route path="/analytics" element={<Navigate to="/reports/conversations" replace />} />
          <Route path="/settings" element={<Navigate to="/settings/account" replace />} />
          <Route path="*" element={<Navigate to="/conversations" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <LocaleProvider>
        <AuthProvider>
          <div className="App">
            <AppRoutes />
          </div>
        </AuthProvider>
      </LocaleProvider>
    </Router>
  );
}

export default App;
